
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import api from "@/services/api.mobile.service";

@Component({
  components: { },
})
export default class SOCContactModal extends Vue{
    @Prop({ default: false, type: Boolean }) visible: boolean;
    @Prop({ default: "", type: String }) socTelephoneNumber: string;

    private async auditCall(){
        await api.auditSocCall();
    }

    @Emit("close-modal")
	private closeModal() {}
}
